import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiFormLabel = {
  styleOverrides: {
    root: {
      color: 'var(--mui-palette-text-secondary)',
      fontSize: '0.8125rem',
      fontWeight: 500,
      lineHeight: 1.4,
      marginBottom: '6px',
    },
  },
} satisfies Components<Theme>['MuiFormLabel'];
